import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Row, Alert } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

import GoogleSignIn from "../../Components/Common/GoogleSignIn";
import ResearchDisclaimer from "../../Components/Common/ResearchDisclaimer";

/**
 * Google is the only way in.
 *
 * The email/password form this replaced was Velzon demo scaffolding — it even
 * shipped with admin@forecastnest.com / 123456 prefilled as its initial values.
 * Every real account already signs in with Google, so the form was a liability
 * without a user. POST /api/login still exists for scripted access; it simply
 * has no page behind it.
 */
const Login = (props) => {
    const [oauthError, setOauthError] = useState(null);

    const handleGoogleSuccess = () => {
        props.router.navigate('/dashboard');
    };

    const handleGoogleError = (error) => {
        console.error('Google login error:', error);
        setOauthError('Could not start Google sign-in. Please try again.');
    };

    // Handle the OAuth round trip: the backend redirects back here with either
    // ?token=&user= on success or ?error= on failure.
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const userStr = urlParams.get('user');
        const error = urlParams.get('error');
        const errorMsg = urlParams.get('error_message');

        if (error) {
            console.error('OAuth error:', error);
            let errorMessage = 'Authentication failed. Please try again.';

            if (error === 'oauth_failed') {
                errorMessage = 'Google authentication failed. Please try again.';
            } else if (error === 'registration_disabled') {
                errorMessage = 'New user registrations are currently disabled. Please contact support if you believe this is an error.';
            } else if (errorMsg) {
                errorMessage = decodeURIComponent(errorMsg);
            }

            setOauthError(errorMessage);
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }

        if (token && userStr) {
            try {
                const userData = JSON.parse(decodeURIComponent(userStr));

                sessionStorage.setItem("authUser", JSON.stringify(userData));
                localStorage.setItem("token", token);
                localStorage.setItem("username", userData.username);

                window.history.replaceState({}, document.title, window.location.pathname);
                props.router.navigate('/dashboard');
            } catch (err) {
                console.error('Error processing OAuth callback:', err);
                setOauthError('Sign-in succeeded but the session could not be read. Please try again.');
            }
        }
    }, [props.router]);

    document.title = "Sign In | ForecastNest - Crypto & Stock Prediction Platform";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content mt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-muted">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <span style={{
                                                fontFamily: 'Inter, sans-serif',
                                                fontSize: '24px',
                                                fontWeight: '700',
                                                color: '#405189',
                                                textDecoration: 'none'
                                            }}>ForecastNest</span>
                                        </Link>
                                    </div>
                                    <p className="mt-3 fs-15 fw-medium">Research management for people who use AI</p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Welcome Back !</h5>
                                            <p className="text-muted mb-0">Sign in to continue to ForecastNest.</p>
                                        </div>

                                        {oauthError ? (
                                            <Alert color="danger" className="mt-4 mb-0">{oauthError}</Alert>
                                        ) : null}

                                        <div className="p-2 mt-4">
                                            <GoogleSignIn
                                                onSuccess={handleGoogleSuccess}
                                                onError={handleGoogleError}
                                                text="Continue with Google"
                                            />
                                            <p className="text-muted text-center fs-13 mt-3 mb-0">
                                                No password to remember. First sign-in creates your account.
                                            </p>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div className="mt-4 text-center text-muted">
                                    <ResearchDisclaimer />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);
